export default __webpack_public_path__ + "static/media/MenuMobile.59a00002.svg";